import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'react-form';

import InputBase from 'forms/InputBase';
import InputBlock from 'forms/InputBlock';

class SelectInput extends InputBase {

  getOptions() {
    return this.props.options;
  }

  render() {
    // fix inconsistent behavior of react-forms (empty string doesn't produce no placeholder but react-form default one)
    let placeholder = typeof this.props.placeholder == 'string' && this.props.placeholder.length == 0 ? " " : this.props.placeholder;
    if (this.props.placeholder === false) placeholder = '';
    if (this.props.labelAsPlaceholder === true) placeholder = this.props.label;

    return (
      <InputBlock size={this.props.size} className={this.blockClassNames()}>
        {this.renderLabel()}
        <Select className={this.inputClassName("input-select")} field={this.props.name} options={this.getOptions()} placeholder={placeholder} onChange={this.props.onChange} />
        {this.props.children}
        {this.renderErrors()}
      </InputBlock>
    )
  }

}

SelectInput.propTypes = {
  name:         PropTypes.string.isRequired,
  type:         PropTypes.string,
  label:        PropTypes.string.isRequired,
  labelSecondary: PropTypes.string,
  size:         PropTypes.string,
  placeholder:  PropTypes.string,
  labelAsPlaceholder:  PropTypes.bool,
  options:      PropTypes.array,
  children:     PropTypes.element,
  errors:       PropTypes.object,
  formApi:      PropTypes.object,
  showErrors:   PropTypes.bool,
  onChange:     PropTypes.func,
};

export default SelectInput;
